<template>
  <div class="about">
    <!-- <ul class="list widthBox">
      <li v-for="(item, index) in aboutList" :key="index">
        <img :src="item.img" alt="" />
      </li>
    </ul> -->
    <div class="profile">
      <div class="proFileBox">
        
        <div class="profileHead">
          <h4 >EBERS</h4>
          <div class="cont" v-html="ebers_info.introduce_one">
           
          </div>
        </div>

        <div v-if="aboutList && !mobile" class="item acea-row row-between" v-for="(item, index) in aboutList">
          <img v-if="index % 2 == 0" class="pic" :src="item.img" alt="">
          <div class="txt" :style="index % 2 == 0 ? 'padding-right: 0px;' : 'padding-left: 0px;'">
            <!-- <p class="en">{{ item.entitle }}</p> -->
            <h4 :style="index % 2 == 0 ? '' : 'padding-left: 0px;'">{{ item.title }}</h4>
            <div class="cont" :style="index % 2 == 0 ? 'padding-right: 0px;' : 'padding-left: 0px;'">
              {{ item.describe }}
            </div>
          </div>
          <img v-if="index % 2 != 0" class="pic" :src="item.img" alt="">
        </div>
        <div v-if="aboutList && mobile" class="item acea-row row-between" v-for="(item, index) in aboutList">
          <img class="pic" :src="item.img" alt="">
          <div class="txt">
            <!-- <p class="en">{{ item.entitle }}</p> -->
            <h4>{{ item.title }}</h4>
            <div class="cont">
              {{ item.describe }}
            </div>
          </div>
        </div>

        <div class="profileFooter">
        <div class="cont" v-html="ebers_info.introduce_two">
        </div>
      </div>
      </div>
    </div>
    <div class="news">
      <ul class="newsList acea-row widthBox">
        <li v-for="(item, index) in newsList" :key="index">
          <h4 v-if="mobile">{{ item.title }}</h4>
          <img :src="item.img" alt="" class="pic" />
          <div class="right">
            <h4 v-if="!mobile">{{ item.title }}</h4>
            <div class="txt">
              <p>{{ item.describe }}</p>
            </div>
          </div>
        </li>
        <li>
          <h4 class="h4">COMPANY VALUES</h4>
          <div class="imgs_box">
            <div v-for="(item,index) in ebers_comany_list" :key="index">
              <img :src="item.img" alt="">
              <p>{{item.title}}</p>
              
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      aboutList: [],
      ebers_comany_list:[],
      ebers_info:[],
      indexData: {},
      center: { lng: 0, lat: 0 },
      mobile: false
    };
  },
  created() {
    this.$api.get("home/index/aboutebers", {}).then((res) => {
      console.log("home/index/aboutebers---------------------", res);
      this.newsList = res.data.ebersculturelist;
      this.aboutList = res.data.eberslist;
      this.ebers_comany_list = res.data.ebers_comany_list
      this.ebers_info = res.data.ebers_info
    });
    var width = document.body.clientWidth
    if (width <= 768) {
      this.mobile = true
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
p{
  white-space: pre-wrap;
}
$paddingTop: 60px;
.about {
  .news {
    padding-top: 50px;

    .newsList {
      li {
        width: 100%;
        background: #fff;
        padding-bottom: 30px;
        margin-bottom: 30px;
        text-align: center;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &:nth-child(3n) {
          margin-right: 0;
        }
        
        .h4{
          text-align: center;
        }
        .h4::after{
          left: 50%;
        }
        .imgs_box{
          display: flex;
          justify-content:space-around;
          width: 100%;
          margin-top: 50px;
          img{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            object-fit: cover;
          }
          div{
            width: 24%;
            // background: #ccc;
            position: relative;
            min-height: 150px;
            p{
              position: absolute;
              font-size: 28px;
            line-height: 150px;
              color: #fff !important;
              text-align: center;
              width: 100%;
            }
          }
          div:hover{
            box-shadow: 0px 8px 20px 0px  rgba(0, 0, 0, 0.2);
          }
        }
        .pic {
          width: 40%;
        }
        .right{
          width: 57%;
          display: flex;
          align-content: center;
          flex-wrap: wrap;
        }
        h4 {
          width: 100%;
          font-size: 32px;
          padding: 30px 0;
          // margin: 0 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #777;
          position: relative;
          text-align: left;
          &::after {
            content: "";
            display: block;
            width: 80px;
            height: 4px;
            background: #777;
            position: absolute;
            bottom: 0;
            left: 0%;
            transform: translate(-50%, 0);
          }
        }

        .txt {
          width: 100%;
          margin-top: 30px;
          // padding: 0 30px;
          box-sizing: border-box;
          text-align: left;
          p {
            color: rgba($color: #777, $alpha: 0.5);
            font-size: 20px;
          }
        }

        &:hover {
          h4 {
            color: #b90f0f !important;

            &::after {
              background: #b90f0f;
            }
          }

          .txt p {
            color: #b90f0f !important;
          }
        }
      }
    }
  }

  .profile {
    padding-top: $paddingTop;

    .proFileBox {
      width: 1400px;
      margin: 0 auto;
      .profileHead,.profileFooter{
        h4{
            font-size: 48px;
            text-align: center;
        }
        .cont{
          margin-top: 50px;
          ::v-deep p {
            font-size: 20px !important;
          }
          ::v-deep span {
            font-size: 20px !important;
          }
        }
      }
      .profileFooter{
        margin-top: 50px;
      }
      .item {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .pic {
          width: calc(50% - 20px);
        }

        .txt {
          width: 50%;

          .en {
            margin-top: 70px;
            font-size: 50px;
            color: rgba($color: #1D2A55, $alpha: 0.35);
          }

          h4 {
            font-size: 48px;
            // color: #1D2A55;
            color: #000;
            padding: 0px 30px;
          }

          .cont {
            margin-top: 30px;
            padding: 20px 30px;
            // background: rgba($color: #1D2A55, $alpha: 0.05);
            font-size: 20px;
            line-height: 150%;
          white-space: pre-wrap;
            // height: 450px;
            // color: #1D2A55;
            color: rgb(119, 119, 119);
            // padding-right: 25%;
            overflow-y: auto;
          }
        }

        &:nth-child(2n) {
          .en {
            // text-align: right;
          }

          h4 {
            // text-align: right;
          }

          .cont {
            // padding-right: 30px;
            // padding-left: 25%;
          }
        }
      }
    }
  }

  .honor {
    padding-top: $paddingTop;
    border-top: 1px solid #1D2A55;
    margin-top: 50px;

    .honorBox {
      padding: 50px 0 40px;
    }
  }

  .team {
    padding-top: $paddingTop;
    border-top: 1px solid #1D2A55;
    margin-top: 50px;

    .teamBox {
      padding: 90px 0 60px;
    }
  }

  .Links {
    background: rgba($color: #1D2A55, $alpha: 1.0);

    .linksBox {
      overflow: hidden;
      padding: 100px 0 80px;
    }

  }

  .partners {
    padding-top: $paddingTop;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 50%;
      position: absolute;
      background: #FFF;
      left: 0;
      top: 0;
      z-index: -1;
    }

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 50%;
      background: rgba($color: #1D2A55, $alpha: 0.05);
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -1;
    }

    .partnersBox {
      padding: 90px 0 60px;
    }


  }

  .botBox {
    text-align: center;
    margin-top: 50px;

    .more {
      display: inline-block;
      width: 160px;
      height: 50px;
      background: #1D2A55;
      color: #FFF;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      position: relative;

      &.color {
        border: 1px solid #FFF;
      }

      .icon {
        position: absolute;
        top: 50%;
        right: -54px;
        width: 77px;
        transform: translate(0, -50%);
      }
    }
  }

  .recruitment {
    padding-top: $paddingTop;
  }

  .contact {
    padding-top: $paddingTop;
    border-top: 1px solid #1D2A55;
    margin-top: 50px;

    .contactBox {
      h4 {
        font-size: 36px;
        color: #1D2A55;
        margin-top: 50px;

        &.mat100 {
          margin-top: 100px;
        }
      }

      .item {
        margin-top: 40px;

        .iconfont {
          font-size: 36px;
          font-weight: bold;
          color: #1D2A55;
          float: left;
        }

        img {
          width: 36px;
          height: 36px;
          float: left;
        }

        .cont {
          margin-left: 86px;
          font-size: 20px;
          line-height: 40px;

          &>div {
            font-size: 20px;
            line-height: 40px;
          }
        }
      }
    }

    .map {
      width: 100%;
      margin-top: 30px;
    }
  }
}

@media screen and(max-width:1400px) {
  .about {
    .profile {
      
      .proFileBox {
        width: 100%;

        .profileHead,.profileFooter{
          h4{
                font-size: 36px;
              text-align: center;
          }
          .cont{
            ::v-deep p{
                font-size: 18px;
            }
          }
      }
        .item {
          .txt {
            .en {
              font-size: 40px;
            }

            h4 {
              font-size: 36px;
              margin-top: 30px;
            }

            .cont {
              font-size: 18px;
              // height: 350px;
            }
          }
        }
      }
    }

    .recruitment {}

    .contact {
      .contactBox {
        h4 {
          font-size: 32px;
        }

        .item {
          img {
            width: 32px;
            height: 32px;
          }

          .cont {
            font-size: 20px;

            .name {
              font-size: 20px;
            }

            .tel {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}

@media screen and(max-width:1200px) {
  .about {
    .profile {
      .proFileBox {
      .profileHead,.profileFooter{
        h4{
              font-size: 32px;
            text-align: center;
        }
        .cont{
          ::v-deep p{
            font-size: 16px;
          }
              
        }
      }
        .item {
          .txt {
            .en {
              font-size: 36px;
              margin-top: 50px;
            }

            h4 {
              font-size: 32px;
            }

            .cont {
              font-size: 16px;
              // height: 300px;
              margin-top: 40px;
            }
          }
        }
      }
    }

    .recruitment {}

    .contact {
      .contactBox {
        h4 {
          font-size: 28px;
        }

        .item {
          img {
            width: 28px;
            height: 28px;
          }

          .cont {
            font-size: 18px;

            .name {
              font-size: 18px;
            }

            .tel {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

@media screen and(max-width:768px) {
  .about {
    .news {
      padding-top: 0px;
      .newsList {

        li {
          box-shadow: none;
          width: 100% !important;
          margin: 0;
          margin-top: 2px;
          text-align: left !important;
          padding-bottom: 0px;
          .pic{
            width: 100%;
          }
          .right{
            width: 100%;
            .txt{
              p{
            font-size: 14px;
              }

            }
          }
          h4{
            font-size: 20px;
          }
        }
        
        .imgs_box{
          display: flex;
          justify-content:space-around;
          width: 100%;
          flex-wrap: wrap;
          margin-top: -16px !important;
          div{
            width: 49% !important;
            background: #ccc;
            p{
              font-size: 16px !important;
            }
            text-align: center;
            height: 150px;
            line-height: 150px;
            margin-bottom: 11px;
          }
          div:hover{
            box-shadow: 0px 8px 20px 0px  rgba(0, 0, 0, 0.2);
          }
        }
        h4 {
          // position: initial !important;
          margin: 0 !important;
        }

        h4::after {
          display: none !important;
        }

        .txt {
          padding: 0 !important;
        }
      }
    }

    .profile {
      padding-top: 15px;
      padding: 15px 15px;
      padding-bottom: 0px;
      .proFileBox {
        margin-bottom: 0px;
      .profileHead,.profileFooter{
        h4{
              font-size: 16px;
            text-align: center;
        }
        .cont{
          margin-top: 16px;
          ::v-deep p{
            font-size: 14px !important;
          }
          ::v-deep span{
            font-size: 14px !important;
          }
              
        }
      }
        .item {
          margin-top: 20px;

          .pic {
            // max-height: 240px;
            width: 100%;
          }

          .txt {
            width: 100%;
            height: auto;
            background: #F5F5F5;
            ;

            .en {
              font-size: 14px;
              line-height: 20px;
              margin-top: 10px;
              padding: 0px 15px;
            }

            h4 {
              font-size: 16px;
              line-height: 20px;
              padding: 0px 15px;
              margin-top: 20px;
              color: #4D4D4D;
            }

            .cont {
              margin-top: 10px;
              max-height: 400px;
              // overflow-y: auto;
              background: none;
              padding: 10px 15px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }

    .honor {
      margin-top: 20px;
      padding-top: 20px;

      .honorBox {
        padding: 20px;
      }
    }

    .team {
      margin-top: 20px;
      padding-top: 20px;

      .teamBox {
        padding: 20px 20px;
      }
    }

    .Links {
      .linksBox {
        padding: 20px 0 20px;
      }
    }

    .botBox {
      margin-top: 20px;
    }

    .partners {
      padding-top: 20px;

      .partnersBox {
        padding: 30px 0 20px;
      }
    }

    .contact {
      padding: 20px 20px 0;
      margin-top: 20px;

      .map {
        height: 200px;
      }

      .m_contact_box {
        margin-top: 20px;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0px 0px 13px 2px rgba(29, 42, 85, 0.10);
        box-sizing: border-box;
        padding: 24px 30px;

        h4 {
          font-size: 14px;
          line-height: 20px;
          color: #1D2A55;
        }

        .item {
          margin-top: 16px;

          .iconfont {
            float: left;
            font-size: 16px;
            line-height: 20px;
          }

          .cont {
            margin-left: 32px;
            font-size: 14px;
            line-height: 20px;
            height: auto;
            color: #1D2A55;
          }
        }
      }
    }
  }
}</style>